import { AVAILABLE_SEARCH_RESULT_KEYS } from '../../../constants';

const getParsedResultKeys = () =>
  AVAILABLE_SEARCH_RESULT_KEYS.reduce((acc, value) => {
    const extraParams =
      value === AVAILABLE_SEARCH_RESULT_KEYS[2] ? '' : `built_on_year, length_overall`;

    return `${acc}... on ${value} {
      __typename,
      id,
      name,
      url,
      image {
        url
      }
      ${extraParams}
    }
    `;
  }, '');

export default getParsedResultKeys;
